import React from 'react';
import {Provider} from 'react-redux';
import {RouterProvider} from 'react-router-dom';

import {router} from 'src/router/browser-router';
import {useWindowResizeTracking} from 'src/utils/userWindowResizeTracking';

import {store} from './store/store';

import './app.component.styl';

export const App = () => {
    useWindowResizeTracking();

    return (
        <Provider store={store}>
            <RouterProvider router={router}/>
        </Provider>
    );
};
